<template>
  <VerifyBody/>
</template>

<script>
// @ is an alias to /src
import VerifyBody from '@/components/VerifyBody.vue'

export default {
  name: 'VerifyView',
  components: {
    VerifyBody
  }
}
</script>
